module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal",
      "appear": ""
    }
  }, [_c('div', {
    staticClass: "modal",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-labelledby": "podcast-modal-title"
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/website/zappelin-logo.png'),
      "alt": "Zappelin logo"
    }
  }), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "podcast-modal-title"
    }
  }, [_vm._v("De Boterhamshow podcast")])]), _vm._v(" "), _c('button', {
    staticClass: "close-button",
    attrs: {
      "aria-label": "Sluiten"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 512 512"
    },
    attrs: {
      "aria-hidden": "true",
      "height": "24px",
      "id": "Layer_1",
      "version": "1.1",
      "viewBox": "0 0 512 512",
      "width": "24px",
      "xml:space": "preserve",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('path', {
    attrs: {
      "d": "M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5  c-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9  c14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.podcasts), function(episode, index) {
    return _c('div', {
      key: episode.id,
      staticClass: "podcast-episode"
    }, [_c('h2', [_vm._v(_vm._s(episode.title))]), _vm._v(" "), _c('p', {
      staticClass: "podcast-episode__description"
    }, [_vm._v(_vm._s(episode.description))]), _vm._v(" "), _c('div', {
      staticClass: "podcast-player"
    }, [_c('audio', {
      ref: "audioPlayers",
      refInFor: true,
      attrs: {
        "preload": "none"
      },
      on: {
        "timeupdate": function($event) {
          _vm.onTimeUpdate(index)
        },
        "ended": function($event) {
          _vm.onEnded(index)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "podcast-player__btn",
      attrs: {
        "aria-label": _vm.playerState[index] && _vm.playerState[index].playing ? 'Pauzeer ' + episode.title : 'Speel ' + episode.title
      },
      on: {
        "click": function($event) {
          _vm.togglePlay(index, episode.url)
        }
      }
    }, [(!_vm.playerState[index] || !_vm.playerState[index].playing) ? _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M8 5v14l11-7z"
      }
    })]) : _c('svg', {
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
      }
    })])]), _vm._v(" "), _c('input', {
      staticClass: "podcast-player__progress",
      attrs: {
        "type": "range",
        "max": _vm.parseDuration(episode.duration),
        "step": "1",
        "aria-label": 'Voortgang ' + episode.title
      },
      domProps: {
        "value": _vm.playerState[index] ? _vm.playerState[index].currentTime : 0
      },
      on: {
        "input": function($event) {
          _vm.onScrub(index, $event)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "podcast-player__time",
      attrs: {
        "aria-live": "off"
      }
    }, [_vm._v("\n                        " + _vm._s(_vm.playerState[index] ? _vm.formatTime(_vm.playerState[index].currentTime) : '0:00') + "/" + _vm._s(_vm.formatDuration(episode.duration)) + "\n                    ")])])])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ba0eccb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PodcastModal.vue
// module id = 705
// module chunks = 64